<template>
<div class="table-section">
  <div class="table-tdrow">
    <div class="table-td w200">
      {{currentMaterial.material.code}}
    </div>
    <div class="table-td w200" v-if="currentMaterial.material.name">
      {{currentMaterial.material.name}}
    </div>
    <div class="table-td w200" v-if="!currentMaterial.material.name">
      {{currentMaterial.material.code}}
    </div>
    <div class="table-td w200">
      {{currentMaterial.quantity.value}} {{currentMaterial.quantity.unit}}
    </div>
    <div class="table-td w200">
      {{currentMaterial.weight.value}} {{currentMaterial.weight.unit}}
    </div>
    <!-- <div class="table-td w200 switch-action" >
      <SwitchBtn
       v-model="currentMaterial.received"
       active-text="Yes"
       inactive-text="NO"
       active-color="#91C38A"
       inactive-color="#fff" />
    </div> -->
     <div class="table-td w200">
       <div v-if="isPodCompleted">{{currentMaterial.shortage_count}}</div>
      <input type="number" v-if="!isPodCompleted" :disabled="isOtpGenerated" @keyup="changeCheck('shortage_count', 'Shortage')" v-model="currentMaterial.shortage_count" min="0" v-bind:max="currentMaterial.quantity.value" />
    </div>
    <div class="table-td w200">
      <div v-if="isPodCompleted">{{currentMaterial.damage_count}}</div>
     <input type="number" v-if="!isPodCompleted" :disabled="isOtpGenerated"  @keyup="changeCheck('damage_count', 'Damage')" v-model="currentMaterial.damage_count" min="0" v-bind:max="currentMaterial.quantity.value" />
    </div>
    <div class="table-td w200">
      <div v-if="isPodCompleted">{{currentMaterial.leakage_count}}</div>
     <input type="number" v-if="!isPodCompleted"  :disabled="isOtpGenerated" @keyup="changeCheck('leakage_count', 'Leakage')" v-model="currentMaterial.leakage_count" min="0" v-bind:max="currentMaterial.quantity.value" />
    </div>
    <div class="table-td w200">
      <div v-if="isPodCompleted">{{currentMaterial.excess_count}}</div>
     <input type="number" v-if="!isPodCompleted"  :disabled="isOtpGenerated" @keyup="changeCheck('excess_count', 'Excess', true)" v-model="currentMaterial.excess_count" min="0" v-bind:max="currentMaterial.quantity.value" />
    </div>
    <div class="table-td w200">
      <div v-if="isPodCompleted">{{currentMaterial.carton_damage_count}}</div>
     <input type="number" v-if="!isPodCompleted"  :disabled="isOtpGenerated" @keyup="changeCheck('carton_damage_count', 'Carton Damage')" v-model="currentMaterial.carton_damage_count" min="0" v-bind:max="currentMaterial.quantity.value" />
    </div>
  </div>

  <div class="comments-area">
    <div>
        <h4>Reason/Comments</h4>
      <div v-if="isPodCompleted">
        {{ currentMaterial.comment }}
      </div >
      <textarea rows="4" cols="50"  v-if="!isPodCompleted" :disabled="isOtpGenerated"  v-model="currentMaterial.comment" placeholder="">
      </textarea>
    </div>
  </div>
</div>
</template>

<script>
export default {
  components: {},
  props: {
    material: Object,
    isPodCompleted: Boolean,
    isOtpGenerated: Boolean,
  },
  data() {
    return {
      knownMaterial: true,
    };
  },
  computed: {
    currentMaterial() {
      return this.material;
    },
  },
  methods: {
    changeCheck(section, name, allowExcess = false) {
      this.currentMaterial[section] = Number(this.currentMaterial[section]);
      if (this.currentMaterial[section] < 0) {
        this.currentMaterial[section] = 0;
      } else if (this.currentMaterial[section] > this.currentMaterial.quantity.value && !allowExcess) {
        this.$error({
          message: `${name} count is greater than material quanity`,
        });
        this.currentMaterial[section] = 0;
      }
    },
  },
};
</script>

<style lang="scss">
$fontBold: 'OpenSans-Bold';
.material-list{
.table-section {
    .comments-area {
        textarea {
            width: 100%;
            padding: 10px;
            border: 1px solid #D7D7D7;
            outline: none;
        }
    }
    .switch-action {
        .el-switch.is-checked .el-switch__core::after {
            margin-left: -15px !important;
        }
        .el-switch__core {
            width: 29.13px !important;
            height: 12.67px;
            box-shadow: inset 0 1px 3px 0 rgba(0,0,0,0.25);
            &:after {
                width: 14.93px;
                height: 14.96px;
                top: -2px;
                box-shadow: 0 1px 2px 0 rgba(0,0,0,0.5);
            }
        }
        .el-switch {
            &__label * {
                font-size: 1.0rem !important;
                font-family:$fontBold;
            }
            &__label {
                color: #CDCDCD;
            }
            &__label.is-active {
                color: #000;
            }
        }
    }
}
}
.comments-area{
  h4{
    margin: 10px 0 10px;
  }
  & {
  margin: 0 10px 10px;
  }
}
</style>
